import React from "react";
import { useSelector } from "react-redux";
import { useIntl, FormattedMessage } from "react-intl";

import styles from "./styles.module.scss";

/**
 * Component to display the matching question results for cell cultures.
 * It shows both predicted and ideal results along with reasons and images.
 */
const MatchingQuestionResults = (props) => {
  const intl = useIntl();
  const { choices, reasons } = useSelector((state) => state.matchingQuestion);

  const IDEAL_CHOICES = {
    index: 3,
    label: intl.formatMessage({
      id: props.ideal_choice,
      defaultMessage: props.ideal_choice,
      description: "",
    }),
  };
  const IDEAL_REASONS = {
    index: -1,
    label: intl.formatMessage({
      id: props.ideal_reason,
      defaultMessage: props.ideal_reason,
      description: "",
    }),
  };

  /**
   * Renders images for a given index.
   *
   * @param {number} index - The index of the image to be rendered.
   */
  const renderImages = (index) => (
    <div className={styles.imageContainer}>
      <img
        alt={intl.formatMessage({
          id: props.img_one_alt,
          defaultMessage: props.img_one_alt,
          description: "",
        })}
        className={styles.image}
        src={require(`./img/${index}.svg`).default}
      />
      <img
        alt={intl.formatMessage({
          id: props.img_two_alt,
          defaultMessage: props.img_two_alt,
          description: "",
        })}
        className={styles.image}
        src={require(`./img/${index}-1.svg`).default}
      />
    </div>
  );

  /**
   * Renders content including images and text for choices and reasons.
   *
   * @param {Object} choices - The choices object containing the index and label.
   * @param {Object} reasons - The reasons object containing the index and label.
   */
  const renderContent = (choices, reasons) => (
    <>
      <div className={styles.resultsChoices}>
        <div className={styles.cardImages}>
          {choices.index !== -1 ? renderImages(choices.index + 1) : null}
        </div>
        <div
          className={styles.cardText}
          aria-label={
            choices.label
              ? intl.formatMessage(
                  {
                    id: props.ariaLabel,
                    defaultMessage: props.ariaLabel,
                    description: "",
                  },
                  {
                    label: intl.formatMessage({
                      id: choices.label,
                      defaultMessage: choices.label,
                      description: "",
                    }),
                  }
                )
              : ""
          }
        >
          {choices.label ? (
            <FormattedMessage
              id={choices.label}
              defaultMessage={choices.label}
              description=""
            />
          ) : (
            ""
          )}
        </div>
      </div>
      <div className={styles.resultsReasons}>
        {reasons.label ? (
          <FormattedMessage
            id={reasons.label}
            defaultMessage={reasons.label}
            description=""
          />
        ) : (
          ""
        )}
      </div>
    </>
  );

  return (
    <div className={styles.results}>
      <h4 className={styles.heading}>
        <FormattedMessage
          id={props.predictions_title}
          defaultMessage={props.predictions_title}
          description=""
        />
      </h4>
      <div className={styles.resultsParts}>
        {renderContent(choices, reasons)}
      </div>

      <h4 className={styles.heading}>
        <FormattedMessage
          id={props.ideal_title}
          defaultMessage={props.ideal_title}
          description=""
        />
      </h4>
      <div className={styles.resultsParts}>
        {renderContent(IDEAL_CHOICES, IDEAL_REASONS)}
      </div>
    </div>
  );
};

export default MatchingQuestionResults;
